/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Edition_SubscriptionInputs */



/**
* | output |
* | --- |
* | "Subscription (offline)" |
*
* @param {License_Edition_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_edition_subscription = /** @type {((inputs?: License_Edition_SubscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Edition_SubscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abonnement (hors ligne)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement (offline)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbonamento (offline)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подписка (офлайн)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suscripción (sin conexión)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅（离线）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプション (オフライン)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सब्सक्रिप्शन (ऑफ़लाइन)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subscrição (offline)")
	return /** @type {LocalizedString} */ ("Subscription (offline)")
});